
console.log("App module registered.");
export const state = {
    loading: false
};

export const mutations = {
    loadingFinish: (state) => {
        state.loading = false;
    },
    loadingStart: (state) => {
        state.loading = true;
    },
};

export const getters = {
    getloading(state) {
        return state.loading;
    },
};

console.log("Mutations")
console.table(mutations);

